/*
 * @Name UEM公共能力JS
 * 主要维护环境的判断，及生产环境的key配置
 */
/* eslint-disable */
var env = 'beta'
// *******************************************************************************************
    env = "beta";
    var isPro = process.env.VUE_APP_BUILD_ENV === 'prod' // 是否是生产环境的判断逻辑
        if (isPro) { // 生产环境
        env = 'pro';
    }
// ********************以上获取环境变量的代码仅供参考，请以您的实际环境判断为准！******************

// 埋码AppKey配置
var hwaAppKeys = {
    "env": env,
    "appKeys": {
        "beta": 'efd3450359ecf96794882b10cdb5772e', // 从UEM的beta环境获取的埋码Key
        "pro": '051e129f1d304b6ea5df93796022d3a0' // 从UEM的生产环境获取的埋码Key
    }
}
// 采集器配置
;(function(h, w, f, t) {
    if (!h[t]) {
        h.GlobalHwaNamespace = h.GlobalHwaNamespace || []
        h.GlobalHwaNamespace.push(t)
        h[t] = function() {
            (h[t].q = h[t].q || []).push(arguments)
        }
        h['trackerload'] = function() {
            (h[t].q = h[t].q || []).unshift(arguments)
        }
        h[t].q = h[t].q || []
    }
    var host = (f['env'] == 'pro') ? 'hwa.his.huawei.com' : 'hwa-beta.his.huawei.com'
    var iframe = w.createElement('iframe');
    (iframe.frameElement || iframe).style.cssText = 'display:none'
    iframe.src = 'javascript:false'; iframe.id = 'hwa_f'
    var where = w.getElementsByTagName('script')[0]
    where.parentNode.insertBefore(iframe, where)
    var doc = iframe.contentWindow.document
    doc.open().write('<body onload="' +
  'var js = document.createElement(\'script\');' +
  'js.src = \'//' + host + '/dist/hwa_f.js\';' +
  'document.body.appendChild(js);">')
    doc.close()
    iframe.contentWindow.aids = f
    iframe.contentWindow.space = t
})(window, document, hwaAppKeys, 'hwa')
